var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M19.25 12a7.25 7.25 0 1 1-14.5 0 7.25 7.25 0 0 1 14.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M9.75 10S10 7.75 12 7.75 14.25 9 14.25 10c0 .751-.423 1.503-1.27 1.83-.515.199-.98.618-.98 1.17v.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))));
};
export { SvgHelp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZyBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggc3Ryb2tlLXdpZHRoPSIxLjUiIGQ9Ik0xOS4yNSAxMmE3LjI1IDcuMjUgMCAxIDEtMTQuNSAwIDcuMjUgNy4yNSAwIDAgMSAxNC41IDBaIi8+PHBhdGggc3Ryb2tlLXdpZHRoPSIxLjUiIGQ9Ik05Ljc1IDEwUzEwIDcuNzUgMTIgNy43NSAxNC4yNSA5IDE0LjI1IDEwYzAgLjc1MS0uNDIzIDEuNTAzLTEuMjcgMS44My0uNTE1LjE5OS0uOTguNjE4LS45OCAxLjE3di4yNSIvPjxwYXRoIGQ9Ik0xMi41IDE2YS41LjUgMCAxIDEtMSAwIC41LjUgMCAwIDEgMSAwWiIvPjwvZz48L3N2Zz4=";